// Buffer polyfill — isomorphic-git's blob/tree creation paths reach
// for Node's Buffer through deeper code paths even though the surface
// API claims browser-compat. Without this, the first sha1 hash call
// during writeFile/commit throws "Cannot read properties of undefined
// (reading 'from')" and the git-store writes never land. Must run
// before any module that imports isomorphic-git — hence the very
// first import.
import { Buffer } from "buffer";
(globalThis as { Buffer?: typeof Buffer }).Buffer = Buffer;

import React from "react";
import { createRoot } from "react-dom/client";
import { App } from "./App";
import "./styles.css";
// Git-canonical port substrate + debug surface. Lazy-initializes the
// in-browser git repo on first mutation; exposes window.__gitStoreDebug
// for DevTools inspection. See docs/git-canonical-port-plan.md.
import "./lib/git-store/debug";
// Phase 3: subscribe auto-push to the commit event bus. No-op when
// the user hasn't configured a backup target yet.
import { initAutoPush } from "./lib/auto-push";
initAutoPush();

const root = document.getElementById("root");
if (!root) throw new Error("missing #root");
createRoot(root).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
